import {
  Stack,
  Box,
  Container,
  Flex,
  Icon,
  Heading,
  Text,
  SimpleGrid,
  HStack,
} from "@chakra-ui/react";
import CombinedHeading from "../../common/CombinedHeading";
import {
  FiGlobe,
  FiZap,
  FiClock,
  FiShield
} from "react-icons/fi";
import { Link } from "react-router-dom";
const YellowstoneFeatures = () => {
  return (
    <>
      <Stack as="div" bg={"#111"}>
        <Container
          maxW={"7xl"}
          pt={{ base: 10, md: 4 }}
          pb={{ base: 4, md: 4 }}
        >
          <Box
            as="div"
            color="brand.midGrey"
            fontSize={{ base: "xs", md: "md" }}
          >
            <CombinedHeading
              topHeading="Fast and reliable"
              mainHeading="Unmatched Streaming Experience"
              subHeading="Experience best-in-class Solana streaming with no credit system, shred acceleration and intelligent reconnections."
              isCenter={true}
            />
            <Box
              as="div"
              bg={"transparent"}
              borderRadius="2xl"
              py={12}
              px={{base: 8, md: 24}}
              border={"2px solid"}
              borderColor="brand.faintGrey"
              mt={14}
            >
              {/* <Heading as="h3" size="md" mb={6}>
                Enterprise-grade Dedicated Nodes
              </Heading> */}
              <SimpleGrid
                columns={{ base: 1, lg: 2 }}
                spacingX="24"
                spacingY="8"
                justifyContent={"space-evenly"}
              >
                <HStack align="flex-start" spacing={4}>
                  <Icon as={FiGlobe} boxSize={6} color={"brand.red"} mt={1} />
                  <Box>
                    <Heading as="h4" size="md" mb={1} color={"brand.white"}>
                      Lag-Free Streaming
                    </Heading>
                    <Text color={"brand.grey"} fontSize="sm">
                      All regions have intelligent load-balancing, making sure you are always connected to a caught up node. Automatic disconnections in case of any lag.
                    </Text>
                  </Box>
                </HStack>

                <HStack align="flex-start" spacing={4}>
                  <Icon as={FiZap} boxSize={6} color={"brand.red"} mt={1} />
                  <Box>
                    <Heading as="h4" size="md" mb={1} color={"brand.white"}>
                      Ultra Fast
                    </Heading>
                    <Text color={"brand.grey"} fontSize="sm">
                      All regions are accelerated by Shredstreams, enabling you to receive updates at the lowest-latency possible on Solana.
                    </Text>
                  </Box>
                </HStack>

                <HStack align="flex-start" spacing={4}>
                  <Icon as={FiShield} boxSize={6} color={"brand.red"} mt={1} />
                  <Box>
                    <Heading as="h4" size="md" mb={1} color={"brand.white"}>
                      No Missed Slot
                    </Heading>
                    <Text color={"brand.grey"} fontSize="sm">
                      Shyft gRPC nodes can replay older slots, making sure you never miss any data, which is crucial for indexing.
                    </Text>
                  </Box>
                </HStack>

                <HStack align="flex-start" spacing={4}>
                  <Icon as={FiClock} boxSize={6} color={"brand.red"} mt={1} />
                  <Box>
                    <Heading as="h4" size="md" mb={1} color={"brand.white"}>
                      Unlimited Streaming
                    </Heading>
                    <Text color={"brand.grey"} fontSize="sm">
                      Our pricing model is simple, no credits, no metering on how much data is being streamed. Experience blazingly-fast unlimited streaming.
                    </Text>
                  </Box>
                </HStack>
              </SimpleGrid>
              <Box pt={8}>
                <Flex justifyContent={"center"}>
                  <Box>
                    <Link
                      as={"a"}
                      href="/dashboard/grpc"
                      _hover={{ textDecoration: "none" }}
                    >
                      <Box
                        width={{ base: "160px", md: "160px" }}
                        bg={"brand.red"}
                        color={"brand.white"}
                        rounded={"full"}
                        height={{ base: '40px', md: '40px' }}
                        py={{ base: "6px", md: "7px" }}
                        _hover={{
                          bg: "brand.white",
                          color: "brand.red",
                        }}
                        style={{
                          transition: "all 0.2s ease",
                        }}
                        textAlign={"center"}
                        fontFamily={"heading"}
                        fontWeight={500}
                        fontSize={{ base: "sm", md: "md" }}
                      >
                        Buy gRPC
                      </Box>
                    </Link>
                  </Box>
                </Flex>
              </Box>
            </Box>
          </Box>
        </Container>
      </Stack>
    </>
  );
};

export default YellowstoneFeatures;